module.exports = __webpack_public_path__ + "static/media/Used Cat Compactors  - Toromont Cat.1c1c0022.jpg";